// src/hooks/useUserDoc.js

import { useUserDocState } from "../context/UserDocContext.jsx";

export function useUserDoc() {
  return useUserDocState();
}
